import React, { Fragment } from 'react'
import { useHistory, withRouter } from "react-router";
import { Link } from "react-router-dom";
import filter from 'ramda/src/filter'
import { Table, Button, Input, Space, PageHeader, message } from 'antd'
import {
    // CopyOutlined,
    DeleteOutlined,
    EditOutlined
} from '@ant-design/icons';
import { networkIosAttribute, networkIosAttributes } from 'src/data'
import Services from 'src/services'
import { useRequest } from 'src/hooks';
import { ConfirmPop } from '../ConfirmPop';
import { mapColumn } from 'src/utils/pipes';
import { useSearchParam } from 'react-use';
import { pipe } from 'ramda';
import { compareBy } from 'src/utils';

export const Ios = withRouter(function({title}: any) {
    const [loading, setLoading] = React.useState(false)
    const [keyword, setKeyword] = React.useState<string>('')

    const sdkVersion = useSearchParam('sdk_version')
    const sdkId = useSearchParam('sdk_id')
    const history = useHistory()
    const editLink = (id: string) => '/network_editor/ios/' + id + '?sdk_version=' + sdkVersion

    const onCell = (record: any) => {
        return {
            onClick: (event: any) => {
                history.push(editLink(record.id))
            }
        };
    }
    const addOnCell = (column: any) => ({ ...column, onCell, className: 'ant-table-pointer' })
    const makeColumn = pipe(mapColumn, addOnCell)

    const columns = [
        {
            ...makeColumn(networkIosAttribute.adNetworkVersionName),
            sorter: {
                compare: compareBy('adNetworkVersionName'),
                multiple: 1,
            },
            width: 200,
            ellipsis: true,
        },
        // {
        //     key: 'id',
        //     dataIndex: 'id',
        //     width: 20,
        //     title: "ID"
        // },
        
        
        // {
        //     key: 'name',
        //     title: "英文名",
        //     render: (record: any) => (
        //         <div>{record.name}{record.nameCn ? `(${record.nameCn})` : ''}</div>
        //     )
        // },
        ...[
            networkIosAttribute.nameEn,
            networkIosAttribute.identification,
            networkIosAttribute.adTypes,
        ]
            .map(mapColumn)
            .map(addOnCell)
            // .slice(1)
        ,
        {
            title: '操作',
            key: 'x',
            width: 100,
            render: (props: any) => {
                return (
                    <Fragment>
                        <Link to={editLink(props?.id)}>
                            <Button type="text" icon={<EditOutlined />} />
                        </Link>
                        {/* <Link to={'/network_editor/ios/copy/' + props?.id}>
                            <Button type="text" icon={<CopyOutlined />} />
                        </Link> */}
                        <ConfirmPop
                            onOk={handleDelete(props?.id)}
                            title='确认删除'
                        >
                            <Button icon={<DeleteOutlined />} type="text" danger />
                        </ConfirmPop>
                    </Fragment>
                )
            }
        },
        
    ]

    const requestDelete = useRequest(Services.iosNetwork.delete)
    const handleDelete = (id: any) => () => {
        return requestDelete({adNetworkId: id})
            .then((res: any) => {
                message.success('删除成功')
                fetchList()
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const [dataSource, setDataSource] = React.useState<any>([])

    const requestList = useRequest(Services.iosNetwork.list)
    const fetchList = () => {
        setLoading(true)
        requestList({
            sdkId
        })
            .then(setDataSource)
            .finally(() => setLoading(false))
    }
    React.useEffect(() => {
        fetchList()
    }, [])

    const filterDataSource = filter((item: any) => (
        !!~item.adNetworkVersionName.toLowerCase()?.indexOf(keyword.toLowerCase()) ||
            !!~item.nameEn.toLowerCase()?.indexOf(keyword.toLowerCase())
    )) 

    const ptitle = (sdkVersion ? `iOS SDK ${sdkVersion} - ` : '') + title

    return <div>
        <PageHeader 
            title={ptitle}
            onBack={() => history.goBack()}
         />
        <Space align="center" style={{marginBottom: '10px'}} wrap>
            <Link to={`/network_editor/ios?sdk_id=${sdkId}&sdk_version=${sdkVersion}`}>
                <Button type="primary">
                    添加广告网络
                </Button>
            </Link>

            <Input onChange={e => setKeyword(e.target.value)} placeholder="版本号/英文名" />
        </Space>

        <Table 
            rowKey="id"
            size="small"
            dataSource={filterDataSource(dataSource) as object[]} 
            columns={columns}
            loading={loading}
            pagination={false}
            expandable={{
                expandedRowRender: (record: any) => {
                    return (
                        <Fragment>
                        {
                            networkIosAttributes
                                .filter((column: any) => !!column.hideInList)
                                .map((column: any) => (
                                    <Fragment key={column.key}>
                                        <p className="m0"><h3 className="m0">{column.title}</h3></p>
                                        {
                                            record[column.key]?.split(/\n/).map((s: any) => 
                                                <p className="m0" key={column.key + '_'}>{s}</p>
                                            )
                                        }
                                        <br />
                                    </Fragment>
                                ))
                        }
                    </Fragment>
                    )
                },
                rowExpandable: (record: any) => record.name !== 'Not Expandable',
            }}
        />
    </div>
})